module.exports = __webpack_public_path__ + "fonts/RenaultLifeOldStyle-Bold.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/fonts/old-style/RenaultLifeOldStyle-Bold.svg
// module id = 342
// module chunks = 0